import axios from "axios";

const json_headers = {
  Accept: "application/json",
};

export default axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: json_headers,
});
